import {FILTERS_ARGS} from "@/app/exercise/modules/payments/core/models/OrdersConst";
import {OrdersFiltersDTO} from "@/app/exercise/modules/payments/core/DTO/OrdersFiltersDto";

export class OrdersFiltersModel {

  constructor(filters) {
    this.filters = new OrdersFiltersDTO(filters);
    this.options = {
      statuses: {
        list: [
          {
            title: 'All',
            value: null
          },
          {
            title: 'Active',
            value: true
          },
          {
            title: 'Inactive',
            value: false
          }
        ]
      }
    };
  }

  getApiData() {
    return {
      [FILTERS_ARGS.SEARCH]: this.filters.search && this.filters.search.length ? this.filters.search : undefined,
      [FILTERS_ARGS.IS_ACTIVE]: this.filters.is_active,
      [FILTERS_ARGS.EXPIRES_IN_FROM]: this.filters.expires_in[0],
      [FILTERS_ARGS.EXPIRES_IN_TO]: this.filters.expires_in[1],
      [FILTERS_ARGS.DEACTIVATED_AT_FROM]: this.filters.deactivated_at[0],
      [FILTERS_ARGS.DEACTIVATED_AT_TO]: this.filters.deactivated_at[1],
      [FILTERS_ARGS.PAID_AT_FROM]: this.filters.paid_at[0],
      [FILTERS_ARGS.PAID_AT_TO]: this.filters.paid_at[1]
    };
  }
}
